import {Component} from '@angular/core';

@Component({
  selector: 'app-d3-page',
  templateUrl: 'd3-page.component.html'
})
export class D3PageComponent {
}
